import React, { useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import { Analytics } from "@vercel/analytics/react"

function App() {
  useEffect(() => {
    document.title = "Tock Buddy | Tock reservation concierge";

    // Track page view
    if (window.gtag) {
      window.gtag('config', 'GA_TRACKING_ID', {
        page_title: 'Tock Buddy Landing Page',
        page_location: window.location.href
      });
    }
    
    // Add smooth scrolling behavior
    document.documentElement.style.scrollBehavior = 'smooth';
    
    ensureDnsPrefetch('//www.exploretock.com');
  }, []);

  return (
    <div className="App">
      <LandingPage />
      <Analytics />
    </div>
  );
}

function ensureDnsPrefetch(href) {
  const existing = document.head.querySelector(`link[rel="dns-prefetch"][href="${href}"]`);
  if (existing) return;

  const link = document.createElement('link');
  link.rel = 'dns-prefetch';
  link.href = href;
  document.head.appendChild(link);
}

export default App;
